import Option, {OptionData} from "@/types/clients/esquire/data/general/option";
import LaundryLog, {LaundryLogData} from "@/types/clients/esquire/data/general/laundry-log";

export type DeviceData = {
  id: number;
  positionable_type: string;
  positionable_id: string;
  class: string;
  device_id: string;
  is_enabled: boolean;
  name: string;
  function: string;
  state: string;
  changed_at: string;
  created_at: string;
  updated_at: string;
  option: OptionData | null;
  laundryLog: LaundryLogData | null;
};

export default class Device {
  public id: number;
  public positionableType: string;
  public positionableId: string;
  public class: string;
  public deviceId: string;
  public isEnabled: boolean;
  public name: string;
  public function: string;
  public state: string;
  public changedAt: string;
  public createdAt: string;
  public updatedAt: string;
  public option: Option | null;
  public laundryLog: LaundryLog | null;

  constructor(data: DeviceData) {
    this.id = data.id as number;
    this.positionableType = data.positionable_type as string;
    this.positionableId = data.positionable_id as string;
    this.class = data.class as string;
    this.deviceId = data.device_id as string;
    this.isEnabled = data.is_enabled as boolean;
    this.name = data.name as string;
    this.function = data.function as string;
    this.state = data.state as string;
    this.changedAt = data.changed_at as string;
    this.createdAt = data.created_at as string;
    this.updatedAt = data.updated_at as string;
    this.option = null;
    this.laundryLog = null;
  }

  public isWasher(): boolean {
    return this.function === "washer";
  }

  public isDryer(): boolean {
    return this.function === "dryer";
  }

  public isOn(): boolean {
    return this.state === "on";
  }

  public isOff(): boolean {
    return this.state === "off";
  }

  public isUnavailable(): boolean {
    return this.state === "unavailable";
  }

  public isHeating(): boolean {
    return this.function === "heating";
  }

  public isPower(): boolean {
    return !this.isHeating();
  }

  public canToggle(): boolean {
    return !this.isUnavailable();
  }

  public getUpdatedAtMs(): number | null {
    const ms = new Date(this.updatedAt).getTime();
    return Number.isNaN(ms) ? null : ms;
  }

  public getRemainingMs(nowMs: number = Date.now()): number | null {
    if (!this.isOn()) return null;

    const updatedAtMs = this.getUpdatedAtMs();
    return updatedAtMs ? updatedAtMs - nowMs : null;
  }

  toDTO(): DeviceData {
    return {
      id: this.id,
      positionable_type: this.positionableType,
      positionable_id: this.positionableId,
      class: this.class,
      device_id: this.deviceId,
      is_enabled: this.isEnabled,
      name: this.name,
      function: this.function,
      state: this.state,
      changed_at: this.changedAt,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
      option: this.option ? this.option.toDTO() : null,
      laundryLog: this.laundryLog ? this.laundryLog : null
    };
  }
}
